"use strict";

var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PhotoboothGifCell;
var _qrcode = require("qrcode.react");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _AzertyKeyboard = _interopRequireDefault(require("./AzertyKeyboard"));
var _utils = require("../utils");
var _html2canvas = _interopRequireDefault(require("html2canvas"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var pulse = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.15);\n  }\n  100% {\n    transform: scale(1);\n  }\n"])));

// Styled Components
var Container = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n  box-sizing: border-box;\n"])));
var ActionButton = _styledComponents.default.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 75%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  margin: 0 auto;\n  display: block;\n\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 20rem;\n  padding: 14px 10px;\n  font-size: 1.4rem;\n  margin-top: 0.3rem;\n  text-transform: uppercase;\n  background: rgba(229,214,241,1);; /* Transparent white */\n  border: none;\n  font-weight: bold;\n  box-shadow: none;\nfont-family: font;\n"])));
var PrintButtonWrapper = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  margin-top: 10px;\n\n"])));
var ButtonGroup = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 1rem;\n"])));
var SecondaryButton = (0, _styledComponents.default)(ActionButton)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: 1rem;\n  // margin-top: 1rem;\n\n\n  font-weight: bolf;\n  background-color: rgba(229,214,241,1);\n\n  box-shadow: none;\n\n  &:hover {\n  }\n"])));
var SecondaryButtonBack = (0, _styledComponents.default)(ActionButton)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: 1rem;\n  // margin-top: 1rem;\n\n\n  font-weight: bolf;\n  background-color: rgba(229,214,241,1);\n\n  box-shadow: none;\n\n  &:hover {\n  }\n"])));
var SecondaryButtonPrint = (0, _styledComponents.default)(ActionButton)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: block;\n  width: 15rem;\n  padding: 14px 10px;\n  font-size: 1rem;\n  background-color: rgba(229,214,241,1);\n  box-shadow: none;\n  top : auto;\n  margin-top : 2.5rem\n"])));
var Preview = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 2em;\n  overflow: hidden;\n  border: none;\n  margin: '0 auto';\n  border-radius: '36px';\n"])));
var PreviewWrapper = _styledComponents.default.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\nposition: absolute;\nbottom: 3%;\npadding: 1em;\nwidth: 70%;\nmargin-left: -1em;\nleft: 15%;\nheight: 70%;\n// background: white;\ndisplay: flex;\nflex-direction: column;\nalign-items: center;\njustify-content: space-between;\n/* Enforce portrait aspect ratio */\n/* margin: 20px auto; Removed margin as fixed positioning handles placement */\n// box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.1);\nz-index: 100; /* Ensure it's above other content */\n"])));
var ImageContainer = _styledComponents.default.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: calc(100% - 60px);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius : 16px;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    // object-fit: contain; /* Preserve aspect ratio and fit inside the frame */\n    overflow: hidden;\n  }\n"])));
var ShareScreenWrapper = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"])));
var RetakeAbsoluteButton = (0, _styledComponents.default)(SecondaryButton)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 200;\n"])));
var BackAbsoluteButton = (0, _styledComponents.default)(SecondaryButton)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 3%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 200;\n"])));
var ShareOptionsContainer = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  // gap: rem;\n\n  width: 100%;\n  max-width: 1080px;\n  padding: 1rem;\n  box-sizing: border-box;\n"])));
var ShareOptionCard = _styledComponents.default.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var EmailCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  background: rgba(122, 103, 66, 0.2);\n  width: 301px;\n  margin-right: 30px;\n"])));
var QRCodeCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\n  width: 500px;\n\n"])));
var PrintCard = (0, _styledComponents.default)(ShareOptionCard)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  width: 240px;\n"])));
var CardTitle = _styledComponents.default.h3(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 1.6rem;\n  text-align: center;\n\n  padding: 0;\n  color: #000000;\n  line-height: 1.2;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var EmailInput = _styledComponents.default.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  width: 240px;\n  height: 36px;\n  min-height: 36px;\n  flex-shrink: 0;\n  padding: 0;\n  border-radius: 100px;\n  background: rgba(255, 255, 255, 0.7);\n  font-family: font;\n  font-size: 15px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n  color: rgba(122, 103, 66, 0.5);\n  cursor: pointer;\n  margin: 12px 0 12px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"])));
var SendButton = _styledComponents.default.button(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  width: 120px;\n  height: 36px;\n  padding: 0;\n  border-radius: 100px;\n  background: #7A6742;\n  color: #FFFFFF;\n  font-family: font;\n  font-size: 18px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  box-sizing: border-box;\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n\n  &:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n"])));
var QRCodeDisplay = _styledComponents.default.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 250px;\n  // height: 250px;\n  margin: 0px auto 35px auto;\n"])));
var PrintIconContainer = _styledComponents.default.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n  height: 97px;\n  margin: 32px auto 0 auto;\n"])));
var PrintButton = _styledComponents.default.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  padding: 0;\n  text-align: center;\n  font-family: font;\n  font-size: 23px;\n  font-weight: 700;\n  color: #000000;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  margin-top: 1.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  ", "\n"])), function (props) {
  return props.disabled && "\n    opacity: 0.6;\n    cursor: not-allowed;\n  ";
});
var ShareFormContainer = _styledComponents.default.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 65%;\n  flex-direction: column;\n  align-items: center;\n  padding: 1rem;\n  z-index: 10;\n  border-radius: 24px;\n  background:rgb(255, 255, 255, 0.2);\n  opacity: 0.4;\n  backdrop-filter: blur(20px);\n"])));
var ShareContent = _styledComponents.default.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 10rem;\n  gap: 0.5rem;\n  align-items: start;\n"])));
var FormTitle = _styledComponents.default.h2(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin: 1rem 0;\n  text-align: center;\n  width: 100%;\n  font-weight: bold;\n  font-family: font;\n  color : #fff;\n"])));
var QRCodeWrapper = _styledComponents.default.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  margin-left: 3rem;\n  background: white;\n  padding: 0.5rem;\n  border-radius: 0.8rem;\n  width: 5rem;\n"])));
var PreviewWrapper2 = _styledComponents.default.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  bottom: 1%;\n  transform: translateX(-50%);\n  width: 75%;\n  padding: 1em;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  z-index: 100;\n"])));
var ShareInput = _styledComponents.default.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  padding: 0.7rem 1rem;\n  border-radius: 2rem;\n  font-size: 1rem;\n  font-family: font;\n  outline: none;\n  border: none;\n  background: #FFFFFF;\n  border: 0.1rem solid #000000;\n  &:focus {\n  }\n"])));
var ShareCheckbox = _styledComponents.default.label(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n  line-height: 1.4;\n\n  input {\n    width: 1rem;\n    height: 1rem;\n\n  }\n  input[type=\"checkbox\"]:checked {\n  background-color: #333;\n}\n"])));
var BackgroundWrapper = _styledComponents.default.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  background-size: cover;\n  background: rgba(0,0,0,0);\n  background-position: center;\n  width: 100%;\n  height: 100%;\n"])));
var ShareButton = (0, _styledComponents.default)(ActionButton)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  margin: 0;\n  width: 40%;\n  border-radius: 2rem;\n  font-size: 1rem;\n  padding: 0.5rem;\n  text-transform: none;\n  background: #FFFFFF;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(12.5px);\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n"])));
var LogoImage = _styledComponents.default.img(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 30%;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n"])));
var LogoImage2 = _styledComponents.default.img(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  height: auto;\n  width: 90%;\n  margin-top: 0.7rem;\n"])));
var ShareForm = _styledComponents.default.form(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n"])));
var CameraContainer = _styledComponents.default.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  // top: 1.3%;\n  // right : 0.2%;\n\n  position: relative;\n  border-radius: 0px;\n  overflow: hidden;\n\n  box-sizing: border-box;\n  background: ", "; /* Fond blanc tant que la cam\xE9ra n\u2019est pas pr\xEAte */\n  \n"])), function (props) {
  return props.cameraReady ? 'transparent' : 'rgba(229,214,241,1)';
});
var Camera = _styledComponents.default.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n"])));
var VideoPreview = _styledComponents.default.video(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  width: 140%;\n  height: 100%;\n  object-fit: contain;\n  /* Rotate 90\xB0 and scale to match captured photo field of view (4:6 crop from rotated video) */\n  transform: ", ";\n  transform-origin: center center;\n  border-radius: 2.2em;\n"])), function (props) {
  return props.mirror ? 'scaleX(-1) rotate(90deg) scale(1.57) translateY(-40px)' : 'rotate(90deg) scale(1.57)';
});

// COMMENTED OUT: Frozen frame feature (may be needed later)
// const FrozenFrame = styled.img`
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   /* Rotate 90° and scale to fill container (scale by container aspect ratio to compensate for rotation) */
//   transform: scaleX(-1) rotate(90deg) scale(1.57); // Mirror effect + 90° rotation like video
//   transform-origin: center center;
//   border-radius: 2.2em;
//   position: absolute;
//   top: 0;
//   left: 0;
//   z-index: 1;
// `;

// const ProcessingOverlay = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(2px);
//   z-index: 100;
//   border-radius: 2.2em;
// `;

// const ProcessingMessage = styled.div`
//   font-family: 'Helvetica Neue', sans-serif;
//   font-size: 1.5rem;
//   font-weight: 600;
//   color: white;
//   text-align: center;
//   padding: 1rem 2rem;
//   background: rgba(0, 0, 0, 0.6);
//   border-radius: 1rem;
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   backdrop-filter: blur(10px);
// `;

var CountdownOverlay = _styledComponents.default.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 4rem;\n  height: 4rem;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.5);\n  box-shadow: 10px 15px 30px rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n"])));
var CountdownNumber = _styledComponents.default.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 1.8rem;\n  font-weight: 700;\n  line-height: 1;\n"])));

// Progress bar container: Shows below camera loader when photo is being processed
var ProgressBarContainer = _styledComponents.default.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%; /* Positioned just below camera loader circle (at 50%) */\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 60%;\n  max-width: 20rem;\n  z-index: 100; /* Higher than GifOverlay (z-index: 50) and CountdownOverlay (z-index: 3) */\n"])));
var ProgressBarWrapper = _styledComponents.default.div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 0.5rem;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  margin-top: 15px;\n  position: relative;\n"])));
var ProgressBarFill = _styledComponents.default.div(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: ", "%;\n  background: #fff;\n  background-size: 1rem 1rem;\n  animation: progressAnimation 0.5s linear infinite;\n  transition: width 0.3s ease-out;\n\n  @keyframes progressAnimation {\n    0% {\n      background-position: 0 0;\n    }\n    100% {\n      background-position: 1rem 1rem;\n    }\n  }\n"])), function (props) {
  return props.progress;
});
var ProgressText = _styledComponents.default.div(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  margin-top: 0.5rem;\n  text-align: center;\n  font-family: font;\n  font-size: 1rem;\n  font-weight: 600;\n  color: white;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n"])));
var GifOverlay = _styledComponents.default.img(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  z-index: 50;\n  pointer-events: none;\n"])));

// COMMENTED OUT: Flash animation feature (may be needed later)
// Flash overlay: Full-screen white flash animation that appears when photo is taken
// Shows for 500ms to simulate camera flash effect
// const FlashOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   background-color: white;
//   z-index: 10000; // High z-index to cover everything
//   pointer-events: none; // Don't block user interactions
//   opacity: ${props => props.show ? 1 : 0};
//   transition: opacity 0.1s ease-out; // Smooth fade transition
// `;

var ControlBar = _styledComponents.default.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* center items horizontally */\n  justify-content: center;\n  position: absolute;\n  bottom: 45%;\n  z-index: 60;\n  width: 100%;\n"])));
var CameraButton = _styledComponents.default.div(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n    padding: 0;\n    background: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    backdrop-filter: none;\n    -webkit-backdrop-filter: none;\n    cursor: pointer;\n\n"])));
var ButtonText = _styledComponents.default.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  font-family: font;\n  font-size: 1.2em;\n  font-weight: 500;\n  letter-spacing: 1px;\n  margin-top: 1rem;\n  animation: ", " 1.2s ease-in-out infinite;\n"])), pulse);
function PhotoboothGifCell(_ref4) {
  var cell = _ref4.cell,
    pageId = _ref4.pageId,
    screenType = _ref4.screenType,
    _ref4$uriTransformer = _ref4.uriTransformer,
    uriTransformer = _ref4$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref4$uriTransformer,
    project = _ref4.project,
    intl = _ref4.intl,
    defaultLanguage = _ref4.defaultLanguage;
  var _ref5 = (0, _react.useState)(''),
    _ref6 = _slicedToArray(_ref5, 2),
    email = _ref6[0],
    setEmail = _ref6[1];
  var _ref7 = (0, _react.useState)({}),
    _ref8 = _slicedToArray(_ref7, 2),
    textDatas = _ref8[0],
    setTextDatas = _ref8[1];
  var _ref9 = (0, _react.useState)(false),
    _ref0 = _slicedToArray(_ref9, 2),
    consent = _ref0[0],
    setConsent = _ref0[1];
  var _ref1 = (0, _react.useState)(true),
    _ref10 = _slicedToArray(_ref1, 2),
    terms = _ref10[0],
    setTerms = _ref10[1];
  var _ref11 = (0, _react.useState)(''),
    _ref12 = _slicedToArray(_ref11, 2),
    link = _ref12[0],
    setLink = _ref12[1];
  var _ref13 = (0, _react.useState)(false),
    _ref14 = _slicedToArray(_ref13, 2),
    isSending = _ref14[0],
    setIsSending = _ref14[1];
  var _ref15 = (0, _react.useState)(null),
    _ref16 = _slicedToArray(_ref15, 2),
    sendStatus = _ref16[0],
    setSendStatus = _ref16[1];
  var _ref17 = (0, _react.useState)('start'),
    _ref18 = _slicedToArray(_ref17, 2),
    step = _ref18[0],
    setStep = _ref18[1];
  var _ref19 = (0, _react.useState)(null),
    _ref20 = _slicedToArray(_ref19, 2),
    capturedImage = _ref20[0],
    setCapturedImage = _ref20[1];
  var _ref21 = (0, _react.useState)(5),
    _ref22 = _slicedToArray(_ref21, 2),
    countdown = _ref22[0],
    setCountdown = _ref22[1];
  var streamRef = (0, _react.useRef)(null);
  var previewCanvasRef = (0, _react.useRef)(null);
  var animationFrameId = (0, _react.useRef)(null);
  var _ref23 = (0, _react.useState)(false),
    _ref24 = _slicedToArray(_ref23, 2),
    hasCamera = _ref24[0],
    setHasCamera = _ref24[1];
  var _ref25 = (0, _react.useState)(null),
    _ref26 = _slicedToArray(_ref25, 2),
    cameraError = _ref26[0],
    setCameraError = _ref26[1];
  var videoRef = (0, _react.useRef)(null);
  var cameraContainerRef = (0, _react.useRef)(null);
  var progressIntervalRef = (0, _react.useRef)(null); // Store progress interval reference
  var _ref27 = (0, _react.useState)(false),
    _ref28 = _slicedToArray(_ref27, 2),
    keyboardVisible = _ref28[0],
    setKeyboardVisible = _ref28[1];
  var _ref29 = (0, _react.useState)(false),
    _ref30 = _slicedToArray(_ref29, 2),
    isSended = _ref30[0],
    setIsSended = _ref30[1];
  var _ref31 = (0, _react.useState)(false),
    _ref32 = _slicedToArray(_ref31, 2),
    printed = _ref32[0],
    setPrinted = _ref32[1];
  var _ref33 = (0, _react.useState)(null),
    _ref34 = _slicedToArray(_ref33, 2),
    imageUrl = _ref34[0],
    setImageUrl = _ref34[1];
  var _ref35 = (0, _react.useState)(''),
    _ref36 = _slicedToArray(_ref35, 2),
    font = _ref36[0],
    setFont = _ref36[1];
  var _ref37 = (0, _react.useState)(false),
    _ref38 = _slicedToArray(_ref37, 2),
    isProcessing = _ref38[0],
    setIsProcessing = _ref38[1]; // Track when photo is being processed (camera loader visible)
  var _ref39 = (0, _react.useState)(0),
    _ref40 = _slicedToArray(_ref39, 2),
    processingProgress = _ref40[0],
    setProcessingProgress = _ref40[1]; // Track processing progress (0-100)
  var _ref41 = (0, _react.useState)(false),
    _ref42 = _slicedToArray(_ref41, 2),
    showImage = _ref42[0],
    setShowImage = _ref42[1];
  var _ref43 = (0, _react.useState)(false),
    _ref44 = _slicedToArray(_ref43, 2),
    showEmail = _ref44[0],
    setShowEmail = _ref44[1];
  var _ref45 = (0, _react.useState)(false),
    _ref46 = _slicedToArray(_ref45, 2),
    showQRCode = _ref46[0],
    setShowQRCode = _ref46[1];
  var _ref47 = (0, _react.useState)(false),
    _ref48 = _slicedToArray(_ref47, 2),
    showPrint = _ref48[0],
    setShowPrint = _ref48[1];
  var _ref49 = (0, _react.useState)(null),
    _ref50 = _slicedToArray(_ref49, 2),
    capturedPreview = _ref50[0],
    setCapturedPreview = _ref50[1];
  var _ref51 = (0, _react.useState)(null),
    _ref52 = _slicedToArray(_ref51, 2),
    shareImage = _ref52[0],
    setShareImage = _ref52[1];
  var emailCardRef = (0, _react.useRef)(null);
  var _ref53 = (0, _react.useState)(textDatas.print),
    _ref54 = _slicedToArray(_ref53, 2),
    printButtonText = _ref54[0],
    setPrintButtonText = _ref54[1];
  var _ref55 = (0, _react.useState)('image'),
    _ref56 = _slicedToArray(_ref55, 2),
    shareStage = _ref56[0],
    setShareStage = _ref56[1];
  // 'image' | 'actions'

  var gpios = [0, 4, 17, 22, 27];
  (0, _react.useEffect)(function () {
    if (step === 'share') {
      setShareStage('image');
      var timer = setTimeout(function () {
        setShareStage('actions');
      }, 7000);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [step]);
  (0, _react.useEffect)(function () {
    if (step === 'share') {
      // reset visibility
      setShowImage(false);
      setShowEmail(false);
      setShowQRCode(false);
      setShowPrint(false);

      // Déclenchements séquentiels
      setTimeout(function () {
        return setShowImage(true);
      }, 0);
      setTimeout(function () {
        return setShowEmail(true);
      }, 500);
      setTimeout(function () {
        return setShowQRCode(true);
      }, 1000);
      setTimeout(function () {
        return setShowPrint(true);
      }, 1500);
    }
  }, [step]);

  // COMMENTED OUT: Flash and frozen frame states (may be needed later)
  // const [showFlash, setShowFlash] = useState(false); // Controls flash animation visibility
  // const [frozenFrame, setFrozenFrame] = useState(null); // Frozen frame image after photo capture

  var gif_uri_print = (0, _utils.i18nData)(cell, 'gif_uri_print', intl, defaultLanguage) || "https://treeosk-assets.s3.eu-west-1.amazonaws.com/images/599b4035-1548-4d96-a206-bc2194b422af.png";
  var gif_uri_print_transformed = uriTransformer(gif_uri_print);
  var gif_uri = (0, _utils.i18nData)(cell, 'gif_uri', intl, defaultLanguage) || 'https://treeosk-assets.s3.eu-west-1.amazonaws.com/images/8457d190-6306-4b93-8430-4bde3230b2a3.png';
  var gif_uri_transformed = uriTransformer(gif_uri);

  // 1. Camera constraints: always 16:9 horizontal
  var VIDEO_WIDTH = 1920;
  var VIDEO_HEIGHT = 1080; // 16:9

  // 2. Capture: crop to 6:4 (horizontal), then rotate to portrait (4:6)
  var CROP_WIDTH = 1200; // 6:4 from 1080 height: 1080 * 1.5 = 1620
  var CROP_HEIGHT = 800; // same as video height

  var ROTATED_WIDTH = CROP_HEIGHT; // 1080 (portrait width)
  var ROTATED_HEIGHT = CROP_WIDTH; // 1620 (portrait height)

  var handleVisibilityChange = function handleVisibilityChange() {
    if (document.visibilityState === 'visible' && (step === 'camera' || step === 'countdown')) {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(function (track) {
          return track.stop();
        });
        streamRef.current = null;
      }
      if (videoRef.current) {
        videoRef.current.srcObject = null;
      }
      setTimeout(function () {
        _initializeCamera();
      }, 300);
    }
  };
  (0, _react.useEffect)(function () {
    if (step === 'camera') {
      _initializeCamera();
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (step !== 'camera' && step !== 'countdown') {
        if (animationFrameId.current) {
          cancelAnimationFrame(animationFrameId.current);
          animationFrameId.current = null;
        }
        if (streamRef.current) {
          streamRef.current.getTracks().forEach(function (track) {
            track.stop();
          });
          streamRef.current = null;
        }
        if (videoRef.current) {
          videoRef.current.srcObject = null;
        }
        setHasCamera(false);
      }
    };
  }, [step]);

  // Pause video feed when processing (UI only - doesn't affect backend)
  (0, _react.useEffect)(function () {
    if (isProcessing && videoRef.current) {
      videoRef.current.pause();
    } else if (!isProcessing && videoRef.current && hasCamera && step === 'camera') {
      // Resume video if we're back to camera step and not processing
      videoRef.current.play().catch(function (e) {
        console.warn('Could not resume video:', e);
      });
    }
  }, [isProcessing, hasCamera, step]);

  // Automatically generate QR code when step becomes 'share' and image is captured
  (0, _react.useEffect)(function () {
    if (step === 'share' && capturedImage && !link && !isSending && cell.qr_code) {
      // Automatically trigger share to generate QR code/link
      handleShare();
    }
  }, [step, capturedImage, link, isSending, cell.qr_code]);
  (0, _react.useEffect)(function () {
    if (project) {
      setFont(project.default_button_font);
    }
  }, []);
  // Helper: Find camera deviceId by label substring
  function getCameraDeviceIdByLabel(_x) {
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  } // Update initializeCamera to use the helper
  function _getCameraDeviceIdByLabel() {
    _getCameraDeviceIdByLabel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(labelSubstring) {
      var devices, cameras, match;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return navigator.mediaDevices.enumerateDevices();
          case 1:
            devices = _context.v;
            // Only available after user has granted camera access at least once
            cameras = devices.filter(function (d) {
              return d.kind === 'videoinput';
            }); // Try to find a camera whose label includes the substring (case-insensitive)
            match = cameras.find(function (cam) {
              return cam.label && cam.label.toLowerCase().includes(labelSubstring.toLowerCase());
            });
            return _context.a(2, match ? match.deviceId : cameras[0] ? cameras[0].deviceId : null);
        }
      }, _callee);
    }));
    return _getCameraDeviceIdByLabel.apply(this, arguments);
  }
  var _initializeCamera = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var labelSubstring, deviceId, constraints, stream, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (animationFrameId.current) {
              cancelAnimationFrame(animationFrameId.current);
              animationFrameId.current = null;
            }
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            _context2.p = 1;
            // Choose the relevant camera by label substring (e.g., "logitech" or your camera's name)
            labelSubstring = cell.cameralabel; // <-- Change this to match your camera label
            console.log({
              cell: cell
            });
            _context2.n = 2;
            return getCameraDeviceIdByLabel(labelSubstring);
          case 2:
            deviceId = _context2.v;
            constraints = {
              video: {
                width: {
                  ideal: VIDEO_WIDTH
                },
                height: {
                  ideal: VIDEO_HEIGHT
                },
                facingMode: 'user',
                deviceId: deviceId ? {
                  exact: deviceId
                } : undefined
              },
              audio: false
            };
            _context2.n = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 300);
            });
          case 3:
            _context2.n = 4;
            return navigator.mediaDevices.getUserMedia(constraints);
          case 4:
            stream = _context2.v;
            if (videoRef.current) {
              videoRef.current.srcObject = stream;
              videoRef.current.onloadedmetadata = function () {
                videoRef.current.play().then(function () {
                  setHasCamera(true);
                  setCameraError(null);
                }).catch(function (e) {
                  setCameraError(e.message);
                });
              };
              streamRef.current = stream;
            }
            _context2.n = 6;
            break;
          case 5:
            _context2.p = 5;
            _t2 = _context2.v;
            setCameraError(_t2.message);
            setHasCamera(false);
            if (step === 'camera' || step === 'countdown') {
              setTimeout(function () {
                _initializeCamera();
              }, 1000);
            }
          case 6:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 5]]);
    }));
    return function initializeCamera() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleTakePhoto = function handleTakePhoto() {
    if (step === 'camera' && hasCamera) {
      setStep('countdown');
      startCountdown();
    }
  };

  // COMMENTED OUT: Frozen frame capture function (may be needed later)
  // Capture frozen frame from video to show while processing
  // const captureFrozenFrame = () => {
  //   if (!videoRef.current) return null;
  //
  //   const video = videoRef.current;
  //   // Check if video is ready
  //   if (video.videoWidth === 0 || video.videoHeight === 0) {
  //     return null;
  //   }

  //   const canvas = document.createElement('canvas');
  //   // Rotate 90°: swap width and height
  //   canvas.width = video.videoHeight;
  //   canvas.height = video.videoWidth;
  //   const ctx = canvas.getContext('2d');
  //
  //   // Rotate 90° clockwise and apply mirror effect to match video display
  //   ctx.translate(canvas.width, 0);
  //   ctx.rotate(Math.PI / 2); // 90° clockwise
  //   ctx.scale(-1, 1); // Mirror effect
  //   ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  //
  //   return canvas.toDataURL('image/jpeg', 0.9);
  // };

  var startCountdown = function startCountdown() {
    setCountdown(5);
    var countdownInterval = setInterval(function () {
      setCountdown(function (prev) {
        if (prev <= 0) {
          clearInterval(countdownInterval);
          // When countdown reaches 0, show camera loader and pause video feed (UI only)
          setIsProcessing(true);
          setProcessingProgress(0); // Reset progress
          // Pause video feed immediately when processing starts (UI only - doesn't affect backend)
          if (videoRef.current) {
            videoRef.current.pause();
          }

          // Start progress animation - increments from 0% to 90% gradually
          // Progress will jump to 100% when actual photo processing completes
          var progress = 0;
          progressIntervalRef.current = setInterval(function () {
            progress += 2; // Increment by 2% every ~200ms
            if (progress >= 90) {
              progress = 90; // Cap at 90% until actual processing completes
            }
            setProcessingProgress(progress);
          }, 200);

          // Capture photo (runs in background while video is paused in UI)
          capturePhoto();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  function printImageData(imageDataUrl) {
    if (printed) return;
    if (window.electronAPI) {
      window.electronAPI.sendImageForPrint(imageDataUrl);
    }
    if (window.Android && typeof window.Android.postMessage === 'function') {
      window.Android.postMessage(imageDataUrl);
    }
    setPrinted(true);
  }
  var fallbackCapturePhoto = function fallbackCapturePhoto() {
    if (!videoRef.current || !previewCanvasRef.current) {
      console.error('❌ Video or canvas not available');
      return;
    }
    var canvas = previewCanvasRef.current;
    var context = canvas.getContext('2d');
    var video = videoRef.current;

    // Check if video is ready
    if (video.videoWidth === 0 || video.videoHeight === 0) {
      console.error('❌ Video not ready');
      // COMMENTED OUT: Frozen frame state reset (may be needed later)
      // setIsProcessing(false);
      // setFrozenFrame(null);
      return;
    }
    // 1. Crop center 6:4 region from 16:9 video
    // Ensure crop dimensions do not exceed actual video size to avoid negative source dimensions
    var sWidth = Math.min(CROP_WIDTH, video.videoWidth);
    var sHeight = Math.min(CROP_HEIGHT, video.videoHeight);
    var sx = Math.max(0, Math.floor((video.videoWidth - sWidth) / 2));
    var sy = Math.max(0, Math.floor((video.videoHeight - sHeight) / 2));
    var targetWidth = sWidth;
    var targetHeight = sHeight;

    // 2. Prepare canvas for portrait (rotated) output
    canvas.width = ROTATED_WIDTH; // 1080
    canvas.height = ROTATED_HEIGHT; // 1620

    var gifImg = new Image(targetWidth, targetHeight);
    gifImg.style.backgroundColor = 'white';
    gifImg.style.width = '100%';
    gifImg.style.height = '100%';
    gifImg.style.objectFit = 'cover';
    gifImg.style.objectPosition = 'center';
    gifImg.height = targetHeight;
    gifImg.width = targetWidth;
    gifImg.style.backgroundSize = 'cover';
    gifImg.crossOrigin = 'Anonymous';

    // Add timeout to prevent infinite waiting
    var timeoutId = setTimeout(function () {
      console.warn('⚠️ GIF image load timeout, proceeding without GIF overlay');
      // Proceed with photo capture even if GIF fails to load
      processPhotoCapture(context, canvas, video, targetWidth, targetHeight, null);
    }, 10000); // 10 second timeout

    gifImg.onload = function () {
      clearTimeout(timeoutId);
      console.log(gifImg);
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg);
    };
    gifImg.onerror = function (error) {
      clearTimeout(timeoutId);
      console.error('❌ Error loading GIF overlay:', error);
      // Proceed with photo capture even if GIF fails to load
      processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, null);
    };
    gifImg.src = gif_uri_print_transformed;
  };

  // Helper function to process photo capture
  var processPhotoCapture = function processPhotoCapture(context, canvas, video, sx, sy, sWidth, sHeight, gifImg) {
    try {
      canvas.width = 1080;
      canvas.height = 1620;

      // --- Création de l'image pour la preview ---
      var previewCanvas = document.createElement('canvas');
      previewCanvas.width = 400; // taille de preview
      previewCanvas.height = 600;
      var previewCtx = previewCanvas.getContext('2d');

      // Dessiner la vidéo avec rotation et crop (comme pour le canvas final)
      previewCtx.save();
      previewCtx.translate(previewCanvas.width / 2, previewCanvas.height / 2);
      previewCtx.rotate(Math.PI / 2); // rotation 90°

      var videoAspect = sWidth / sHeight;
      var canvasAspect = previewCanvas.height / previewCanvas.width; // inversé après rotation
      var drawWidth, drawHeight;
      if (videoAspect > canvasAspect) {
        drawHeight = previewCanvas.width;
        drawWidth = previewCanvas.width * videoAspect;
      } else {
        drawWidth = previewCanvas.height;
        drawHeight = previewCanvas.height / videoAspect;
      }
      previewCtx.drawImage(video, sx, sy, sWidth, sHeight, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
      previewCtx.restore();
      var previewData = previewCanvas.toDataURL('image/png');
      setCapturedPreview(previewData); // state pour preview

      // --- Canvas pour l'image à partager (GIF plein écran) ---
      var shareCanvas = document.createElement('canvas');
      shareCanvas.width = canvas.width; // même taille que l'impression
      shareCanvas.height = canvas.height;
      var shareCtx = shareCanvas.getContext('2d');

      // Dessiner la vidéo
      shareCtx.clearRect(0, 0, canvas.width, canvas.height);
      shareCtx.fillStyle = 'white';
      shareCtx.fillRect(0, 0, canvas.width, canvas.height);
      shareCtx.save();
      shareCtx.translate(shareCanvas.width / 2, shareCanvas.height / 2);
      shareCtx.rotate(Math.PI / 2); // rotation 90°

      var drawW2, drawH2;
      var canvasAspectFinal2 = canvas.height / canvas.width;
      if (videoAspect > canvasAspectFinal2) {
        drawH2 = canvas.width;
        drawW2 = canvas.width * videoAspect;
      } else {
        drawW2 = canvas.height;
        drawH2 = canvas.height / videoAspect;
      }
      shareCtx.drawImage(video, sx, sy, sWidth, sHeight, -drawW2 / 2, -drawH2 / 2, drawW2, drawH2);
      shareCtx.restore();

      // Dessiner le GIF **plein écran**, sans scale ni offset
      if (gifImg) {
        shareCtx.drawImage(gifImg, 0, 0, shareCanvas.width, shareCanvas.height);
      }

      // Stocker dans l'état
      var shareData = shareCanvas.toDataURL('image/png');
      setShareImage(shareData);

      // --- Canvas principal pour l'impression ---
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = 'white';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.save();

      // On centre et on rotate
      context.translate(canvas.width / 2, canvas.height / 2);
      context.rotate(Math.PI / 2);

      // --- Calcul "cover" pour que l'image recouvre totalement le canvas ---
      var canvasAspectFinal = canvas.height / canvas.width;
      var drawW, drawH;
      if (videoAspect > canvasAspectFinal) {
        drawH = canvas.width; // hauteur = largeur canvas
        drawW = canvas.width * videoAspect; // largeur plus grande que canvas si nécessaire
      } else {
        drawW = canvas.height; // largeur = hauteur canvas
        drawH = canvas.height / videoAspect; // hauteur plus grande que canvas si nécessaire
      }

      // --- Centrage exact pour recouvrir le canvas ---
      var offsetX = -drawW / 2;
      var offsetY = -drawH / 2;
      context.drawImage(video, sx, sy, sWidth, sHeight, offsetX, offsetY, drawW, drawH);
      context.restore();

      // --- Superposer GIF seulement pour l'impression ---
      if (gifImg) {
        // const scale = 0.986; 
        // const gifWidth = canvas.width * scale; 
        // const gifHeight = canvas.height * scale; 
        // const mmToPx = (mm) => Math.round(mm * 300 / 25.4); 
        // const offsetX = mmToPx(1); 
        // const offsetY = mmToPx(0.3)
        // const gifX = (canvas.width - gifWidth) / 2 + offsetX; 
        // const gifY = (canvas.height - gifHeight) / 2 + offsetY; 
        // context.drawImage(gifImg, gifX, gifY, gifWidth, gifHeight);
        // Grande imprimante
        context.drawImage(gifImg, 0, 0, canvas.width, canvas.height);
      }
      var imageData = canvas.toDataURL('image/png');
      setCapturedImage(imageData); // state pour l'impression / partage

      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setProcessingProgress(100);
      setTimeout(function () {
        setIsProcessing(false);
        setProcessingProgress(0);
        setStep('share');
      }, 300);
    } catch (error) {
      console.error('❌ Error processing photo capture:', error);
      if (progressIntervalRef.current) clearInterval(progressIntervalRef.current);
      setIsProcessing(false);
      setProcessingProgress(0);
    }
  };
  var capturePhoto = function capturePhoto() {
    fallbackCapturePhoto(); // Always use fallback to ensure GIF is drawn
    // console.log('treeosk-btn-' + cell.gpio_number);
  };
  var handleRetake = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            setCapturedImage(null);
            setLink(''); // Reset link so it can be regenerated for new photo
            setIsSended(false); // Reset email sent status
            setPrinted(false);
            setPrintButtonText(textDatas.print);
            // Clear progress interval if still running
            if (progressIntervalRef.current) {
              clearInterval(progressIntervalRef.current);
              progressIntervalRef.current = null;
            }
            setIsProcessing(false); // Reset processing state
            setProcessingProgress(0); // Reset progress

            // Clean up existing camera stream
            if (streamRef.current) {
              streamRef.current.getTracks().forEach(function (track) {
                return track.stop();
              });
              streamRef.current = null;
            }
            if (videoRef.current) {
              videoRef.current.srcObject = null;
            }
            setHasCamera(false);
            setStep('camera');
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleRetake() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleShare = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
      var img, imageData, response, record, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (e) {
              e.preventDefault();
            }
            setSendStatus(null);
            _context4.p = 1;
            if (!(email && !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(email))) {
              _context4.n = 2;
              break;
            }
            throw new Error('Invalid email address');
          case 2:
            if (shareImage) {
              _context4.n = 3;
              break;
            }
            throw new Error('No captured image available');
          case 3:
            // Set sending state only after we start the actual upload
            setIsSending(true);

            // Use the original high-resolution capturedImage (2160x3240px) for digital/QR code
            // Convert PNG to high-quality JPEG to reduce file size while maintaining quality
            img = new Image();
            img.crossOrigin = 'anonymous';
            _context4.n = 4;
            return new Promise(function (resolve, reject) {
              img.onload = function () {
                // Create a canvas matching the loaded image natural size to avoid any squash/stretch
                var naturalW = img.naturalWidth || img.width;
                var naturalH = img.naturalHeight || img.height;
                var canvas = document.createElement('canvas');
                canvas.width = naturalW;
                canvas.height = naturalH;
                var ctx = canvas.getContext('2d');

                // Draw the image at its natural size
                ctx.drawImage(img, 0, 0, naturalW, naturalH);

                // Convert to high-quality JPEG (0.95 quality for good balance between size and quality)
                var jpegData = canvas.toDataURL('image/jpeg', 0.95);
                resolve(jpegData);
              };
              img.onerror = reject;
              img.src = shareImage;
            });
          case 4:
            imageData = _context4.v;
            setImageUrl(imageData);
            _context4.n = 5;
            return fetch("".concat(project.backEndUri, "/send_photo"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cell_id: cell.id,
                image: imageData,
                // Utiliser l'image capturée
                email: email,
                consent: consent,
                terms: terms,
                project_id: project.id
              })
            });
          case 5:
            response = _context4.v;
            if (response.ok) {
              _context4.n = 6;
              break;
            }
            throw new Error('Upload failed');
          case 6:
            _context4.n = 7;
            return response.json();
          case 7:
            record = _context4.v;
            setSendStatus('success');
            setLink(record.image_uri);
            setEmail('');
            setConsent(false);
            if (email) {
              setIsSended(true);
            }

            // Only set isSending to false after link is set and QR code can render
            setIsSending(false);
            _context4.n = 9;
            break;
          case 8:
            _context4.p = 8;
            _t3 = _context4.v;
            setSendStatus('error: ' + _t3);
            setIsSending(false);
          case 9:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 8]]);
    }));
    return function handleShare(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var resetAll = function resetAll() {
    setEmail('');
    setConsent(false);
    setTerms(true);
    setLink('');
    setIsSending(false);
    setSendStatus(null);
    setCapturedImage(null);
    setCapturedPreview(null);
    setShareImage(null);
    setCountdown(5);
    setIsProcessing(false);
    setProcessingProgress(0);
    setIsSended(false);
    setPrinted(false);
    setShowImage(false);
    setShowEmail(false);
    setShowQRCode(false);
    setShowPrint(false);
    setShareStage('image');

    // stop camera
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(function (track) {
        return track.stop();
      });
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };
  (0, _react.useEffect)(function () {
    var timeout;
    var resetTimer = function resetTimer() {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        console.log('⏰ Inactivité → retour start');
        resetAll();
        setStep('start');
      }, 120000); // 2 minutes
    };
    var events = ['click', 'touchstart', 'mousemove', 'keydown'];
    events.forEach(function (event) {
      return window.addEventListener(event, resetTimer);
    });
    resetTimer();
    return function () {
      clearTimeout(timeout);
      events.forEach(function (event) {
        return window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  // Textes par défaut (repli). Les champs éditables de la cellule, quand ils sont renseignés,
  // priment via i18nData(cell, '<champ>_text', ...) aux points d'affichage (look/buttonTake/
  // conditions). NB : `description` (description_text) et `conditions2` (conditions2_text) ne
  // sont affichés nulle part dans la mise en page actuelle — les renseigner dans l'admin n'a
  // donc aucun effet tant qu'aucun point d'affichage n'est ajouté.
  (0, _react.useEffect)(function () {
    switch (intl.locale) {
      case 'fr':
        setTextDatas({
          description: 'Recevoir la photo par email ou scanner le QR-code.',
          buttonDownload: 'Télécharger la photo',
          buttonRetake: 'Reprendre la photo',
          buttonTake: 'Appuyer pour commencer',
          send: 'Envoyer',
          sendByEmail: 'Envoyer par mail',
          // <-- ajouté
          conditions: 'J\'accepte de recevoir la photo sur mon adresse email',
          conditions2: 'J\'ai lu et j\'accepte les termes et conditions.',
          sent: 'Photo envoyée !',
          look: 'Regardez la caméra',
          preparingPhoto: 'Préparation de la photo...',
          almostThere: 'Presque terminé...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRESSION ...',
          print: 'IMPRIMER'
        });
        break;
      case 'nl':
        setTextDatas({
          description: 'Ontvang de foto per e-mail of scan de QR-code.',
          buttonDownload: 'Download de foto',
          buttonRetake: 'Hernoemen',
          buttonTake: 'Maak een foto',
          send: 'Verzenden',
          sendByEmail: 'Verzenden per e-mail',
          // <-- ajouté
          conditions: 'Ik ga akkoord met het ontvangen van de foto op mijn e-mailadres',
          conditions2: 'Ik heb de algemene voorwaarden gelezen en ga ermee akkoord.',
          sent: 'Foto verzonden!',
          look: 'Kijk naar de camera',
          preparingPhoto: 'Foto voorbereiden...',
          almostThere: 'Bijna klaar...',
          emailPlaceholder: 'EMAIL',
          printed: 'AFGEDRUKT',
          print: 'AFDRUKKEN'
        });
        break;
      case 'en':
        setTextDatas({
          description: 'RECEIVE THE PHOTO BY EMAIL OR SCAN THE QR CODE.',
          buttonDownload: 'DOWNLOAD PHOTO',
          buttonRetake: 'RETAKE PHOTO',
          buttonTake: 'TOUCH TO START',
          send: 'SEND',
          sendByEmail: 'SEND BY EMAIL',
          conditions: 'I AGREE TO RECEIVE THE PHOTO AT MY EMAIL ADDRESS',
          conditions2: 'I HAVE READ AND AGREE TO THE TERMS AND CONDITIONS.',
          sent: 'PHOTO SENT!',
          look: 'LOOK AT THE CAMERA',
          preparingPhoto: 'PREPARING PHOTO...',
          almostThere: 'ALMOST THERE...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
      case 'de':
        setTextDatas({
          description: 'Erhalten Sie das Foto per E-Mail oder scannen Sie den QR-Code.',
          buttonDownload: 'Foto herunterladen',
          buttonRetake: 'Foto erneut aufnehmen',
          buttonTake: 'Foto aufnehmen',
          send: 'Senden',
          sendByEmail: 'Per E-Mail senden',
          // <-- ajouté
          conditions: 'Ich stimme zu, das Foto an meine E-Mail-Adresse zu erhalten',
          conditions2: 'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie.',
          sent: 'Foto gesendet!',
          look: 'Schau in die Kamera',
          preparingPhoto: 'Foto wird vorbereitet...',
          almostThere: 'Fast fertig...',
          emailPlaceholder: 'EMAIL',
          printed: 'GEDRUCKT',
          print: 'DRUCKEN'
        });
        break;
      case 'es':
        setTextDatas({
          description: 'Recibe la foto por correo electrónico o escanea el código QR.',
          buttonDownload: 'Descargar foto',
          buttonRetake: 'Volver a tomar la foto',
          buttonTake: 'Tomar foto',
          send: 'Enviar',
          sendByEmail: 'Enviar por correo',
          // <-- ajouté
          conditions: 'Acepto recibir la foto en mi dirección de correo electrónico',
          conditions2: 'He leído y acepto los términos y condiciones.',
          sent: '¡Foto enviada!',
          look: 'Mira a la cámara',
          preparingPhoto: 'Preparando foto...',
          almostThere: 'Casi listo...',
          emailPlaceholder: 'EMAIL',
          printed: 'IMPRESO',
          print: 'IMPRIMIR'
        });
        break;
      default:
        setTextDatas({
          description: 'RECEIVE THE PHOTO BY EMAIL OR SCAN THE QR CODE.',
          buttonDownload: 'DOWNLOAD PHOTO',
          buttonRetake: 'RETAKE PHOTO',
          buttonTake: 'TOUCH TO START',
          send: 'SEND',
          sendByEmail: 'SEND BY EMAIL',
          conditions: 'I AGREE TO RECEIVE THE PHOTO AT MY EMAIL ADDRESS',
          conditions2: 'I HAVE READ AND AGREE TO THE TERMS AND CONDITIONS.',
          sent: 'PHOTO SENT!',
          look: 'LOOK AT THE CAMERA',
          preparingPhoto: 'PREPARING PHOTO...',
          almostThere: 'ALMOST THERE...',
          emailPlaceholder: 'EMAIL',
          printed: 'PRINTED',
          print: 'PRINT'
        });
        break;
    }
  }, [intl.locale, defaultLanguage]);
  return /*#__PURE__*/_react.default.createElement(BackgroundWrapper, {
    style: {
      color: cell.text_color,
      fontFamily: font
    }
  }, /*#__PURE__*/_react.default.createElement(Container, null, step === 'start' && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(ActionButton, {
    onClick: function onClick() {
      resetAll(); // important
      setStep('camera');
    }
  }, "START")), (step === 'camera' || step === 'countdown') && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CameraContainer, {
    className: "camera-container",
    ref: cameraContainerRef,
    cameraReady: hasCamera
  }, /*#__PURE__*/_react.default.createElement(Camera, null, /*#__PURE__*/_react.default.createElement(VideoPreview, {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    mirror: true,
    style: {
      display: hasCamera ? 'block' : 'none' // <--- invisible tant que pas prêt
    }
    // style={{ display: isProcessing && frozenFrame ? 'none' : 'block' }}
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(GifOverlay, {
    src: gif_uri_transformed,
    alt: "Frame overlay"
  }), step === 'countdown' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, countdown > 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, countdown > 3 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      top: '20%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 16000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(AnimatedArrows, {
    cell: cell,
    font: font,
    intl: intl,
    textDatas: textDatas
  }), /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: {
      color: '#ffffff'
    }
  }, (0, _utils.i18nData)(cell, 'look_text', intl, defaultLanguage) || textDatas.look))) : /*#__PURE__*/
  // Countdown classique 3,2,1
  _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CountdownOverlay, null, /*#__PURE__*/_react.default.createElement(CountdownNumber, null, 4 - countdown)))) :
  // Dès que countdown = 0, on affiche le processing
  isProcessing && /*#__PURE__*/_react.default.createElement(ProgressBarContainer, null, /*#__PURE__*/_react.default.createElement(ProgressText, null, processingProgress < 50 ? "YOUR PHOTO IS BEING PREPARED..." : "WE ARE ALMOST THERE..."), /*#__PURE__*/_react.default.createElement(ProgressBarWrapper, null, /*#__PURE__*/_react.default.createElement(ProgressBarFill, {
    progress: processingProgress
  }))))))), step !== 'countdown' && /*#__PURE__*/_react.default.createElement(ControlBar, null, /*#__PURE__*/_react.default.createElement(CameraButton, {
    onClick: handleTakePhoto
  }, /*#__PURE__*/_react.default.createElement(ButtonText, {
    style: {
      color: cell.text_color
    }
  }, "  ", (0, _utils.i18nData)(cell, 'button_take_text', intl, defaultLanguage) || textDatas.buttonTake)))), step === 'share' && shareStage === 'image' && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: '100%',
      width: '100%',
      // top: '1.2%',
      // right : '0.6%',
      position: 'relative'
    }
  }, capturedPreview && /*#__PURE__*/_react.default.createElement("div", {
    id: "preview-wrapper",
    style: {
      position: 'relative',
      height: '100%',
      width: '100%',
      // top: '1.22%',
      // right : '0.62%',
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      outline: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: capturedPreview,
    alt: "Preview avec rotation",
    crossOrigin: "anonymous",
    style: {
      display: 'block',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      border: 'none',
      boxShadow: 'none',
      outline: 'none'
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: gif_uri_transformed,
    alt: "Cadre overlay",
    crossOrigin: "anonymous",
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none'
    }
  }))), step === 'share' && shareStage === 'actions' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundImage: "url(https://dev--treeosk-assets.s3.eu-west-1.amazonaws.com/images/b8ae4b6e-36a4-40ab-95e9-e94ba7d4b45b.png)",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '100%',
      height: '100%',
      position: 'relative',
      // IMPORTANT pour absolute children
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '2rem',
      padding: '2rem',
      boxSizing: 'border-box',
      paddingTop: '6rem'
    }
  }, /*#__PURE__*/_react.default.createElement(SecondaryButton, {
    onClick: handleRetake,
    style: {
      position: 'absolute',
      top: '35%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 200,
      background: cell.button_retake_background_color,
      color: cell.button_retake_text_color,
      border: "0.3em solid ".concat(cell.button_retake_border_color || '#FFFFFF')
    }
  }, "RETAKE PHOTO"), /*#__PURE__*/_react.default.createElement(SecondaryButtonBack, {
    style: {
      position: 'absolute',
      top: 'auto',
      bottom: '3%',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 10
    },
    onClick: function onClick() {
      resetAll();
      setStep('start');
    }
  }, "BACK"), /*#__PURE__*/_react.default.createElement(ShareOptionsContainer, null, cell.email && /*#__PURE__*/_react.default.createElement(EmailCard, {
    ref: emailCardRef
  }, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#ffffff"
  }, (0, _utils.i18nData)(cell, 'send_by_email_text', intl, defaultLanguage) || textDatas.sendByEmail), /*#__PURE__*/_react.default.createElement(EmailInput, {
    onClick: function onClick() {
      return setKeyboardVisible(true);
    }
  }, email || (0, _utils.i18nData)(cell, 'email_placeholder_text', intl, defaultLanguage) || textDatas.emailPlaceholder || 'EMAIL'), /*#__PURE__*/_react.default.createElement(SendButton, {
    onClick: function onClick(e) {
      if (isSending) return;
      e.preventDefault();
      e.stopPropagation();
      handleShare(e);
    },
    disabled: !email || !consent || isSending
  }, (0, _utils.i18nData)(cell, 'send', intl, defaultLanguage) || textDatas.send), isSended && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: 'green',
      fontSize: '0.8rem',
      marginTop: '0.5rem'
    }
  }, (0, _utils.i18nData)(cell, 'sent_text', intl, defaultLanguage) || textDatas.sent), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      marginTop: '0.5rem',
      width: '90%'
    }
  }, /*#__PURE__*/_react.default.createElement(ShareCheckbox, {
    style: {
      fontFamily: font,
      fontSize: '0.5rem'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    checked: consent,
    onChange: function onChange(e) {
      return setConsent(e.target.checked);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#fff',
      fontFamily: font
    }
  }, (0, _utils.i18nData)(cell, 'conditions1_text', intl, defaultLanguage) || textDatas.conditions)))), showQRCode && cell.qr_code && /*#__PURE__*/_react.default.createElement(QRCodeCard, null, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#000000"
  }, "DOWNLOAD PHOTO"), /*#__PURE__*/_react.default.createElement(QRCodeDisplay, null, link ? /*#__PURE__*/_react.default.createElement(_qrcode.QRCodeSVG, {
    value: link,
    size: 200,
    bgColor: "transparent"
  }) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '220px',
      height: '220px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '60px',
      height: '60px',
      border: '4px solid rgba(122, 103, 66, 0.3)',
      borderTop: '4px solid #7A6742',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }
  })))), showPrint && cell.print && /*#__PURE__*/_react.default.createElement(PrintCard, null, /*#__PURE__*/_react.default.createElement(CardTitle, {
    color: "#000000"
  }, printed ? (0, _utils.i18nData)(cell, 'printed_text', intl, defaultLanguage) || textDatas.printed || 'PRINTED' : (0, _utils.i18nData)(cell, 'print_text', intl, defaultLanguage) || textDatas.print || 'PRINT'), /*#__PURE__*/_react.default.createElement(PrintButtonWrapper, null, /*#__PURE__*/_react.default.createElement(SecondaryButtonPrint, {
    onClick: function onClick() {
      if (!capturedImage || printed) return;
      printImageData(capturedImage);
      setPrintButtonText(textDatas.printed);
      gpios.forEach(function (gpio) {
        console.log('treeosk-btn-' + gpio);
      });
    },
    disabled: printed
  }, "HERE")))), keyboardVisible && cell.email && /*#__PURE__*/_react.default.createElement(_AzertyKeyboard.default, {
    field_name: 'Email',
    setVisible: setKeyboardVisible,
    project: project,
    input: email,
    setInput: setEmail,
    anchorRef: emailCardRef
  }))), /*#__PURE__*/_react.default.createElement("canvas", {
    ref: previewCanvasRef,
    width: 1080,
    height: 1620,
    style: {
      display: 'none',
      width: '1080px',
      height: '1620px'
    }
  })));
}
function AnimatedArrows(_ref57) {
  var cell = _ref57.cell;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "80",
    viewBox: "0 0 24 48",
    style: {
      marginTop: "2rem"
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, "\n            .moveUp {\n              animation: moveUp 0.8s ease-in-out infinite alternate;\n              transform-origin: 50% 50%;\n              transform-box: fill-box;\n            }\n\n            @keyframes moveUp {\n              0% { transform: translateY(0); }\n              100% { transform: translateY(-6px); }\n            }\n          "), /*#__PURE__*/_react.default.createElement("g", {
    className: "moveUp"
  }, /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 10 12 3 19 10",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 20 12 13 19 20",
    fill: "none",
    stroke: "#bbbbbb",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    points: "5 30 12 23 19 30",
    fill: "none",
    stroke: "#333333",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}